<template>
	<div id="ditu-app">
		<div id="ditu-main"></div>
	</div>
</template>
<script>
	export default {
		name: "ditu-app",
		methods: {
			convertData(){
				var geoCoordMap = {
					'海门': [121.15, 31.89]
				}
				
				var convertData = function(data) {
					var res = [];
					for (var i = 0; i < data.length; i++) {
						var geoCoord = geoCoordMap[data[i].name];
						if (geoCoord) {
							res.push({
								name: data[i].name,
								value: geoCoord.concat(data[i].value)
							});
						}
					}
					return res;
				};
			},
			drawChart() {
				let _this=this
					// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById("ditu-main"));
				var data = [{
					name: '海门',
					value: 9
				}]
				var geoCoordMap = {
					'海门': [121.15, 31.89]
				}

				/* var convertData = function(data) {
					var res = [];
					for (var i = 0; i < data.length; i++) {
						var geoCoord = geoCoordMap[data[i].name];
						if (geoCoord) {
							res.push({
								name: data[i].name,
								value: geoCoord.concat(data[i].value)
							});
						}
					}
					return res;
				}; */

				let option = {
					title: {
						text: '商品销售分布图',
					/* 	subtext: 'data from PM25.in',
						sublink: 'http://www.pm25.in', */
						left: 'center'
					},
					tooltip: {
						trigger: 'item'
					},
					bmap: {
						center: [104.114129, 37.550339],
						zoom: 5,
						roam: true,
						mapStyle: {
							styleJson: [{
								'featureType': 'water',
								'elementType': 'all',
								'stylers': {
									'color': '#d1d1d1'
								}
							}, {
								'featureType': 'land',
								'elementType': 'all',
								'stylers': {
									'color': '#f3f3f3'
								}
							}, {
								'featureType': 'railway',
								'elementType': 'all',
								'stylers': {
									'visibility': 'off'
								}
							}, {
								'featureType': 'highway',
								'elementType': 'all',
								'stylers': {
									'color': '#fdfdfd'
								}
							}, {
								'featureType': 'highway',
								'elementType': 'labels',
								'stylers': {
									'visibility': 'off'
								}
							}, {
								'featureType': 'arterial',
								'elementType': 'geometry',
								'stylers': {
									'color': '#fefefe'
								}
							}, {
								'featureType': 'arterial',
								'elementType': 'geometry.fill',
								'stylers': {
									'color': '#fefefe'
								}
							}, {
								'featureType': 'poi',
								'elementType': 'all',
								'stylers': {
									'visibility': 'off'
								}
							}, {
								'featureType': 'green',
								'elementType': 'all',
								'stylers': {
									'visibility': 'off'
								}
							}, {
								'featureType': 'subway',
								'elementType': 'all',
								'stylers': {
									'visibility': 'off'
								}
							}, {
								'featureType': 'manmade',
								'elementType': 'all',
								'stylers': {
									'color': '#d1d1d1'
								}
							}, {
								'featureType': 'local',
								'elementType': 'all',
								'stylers': {
									'color': '#d1d1d1'
								}
							}, {
								'featureType': 'arterial',
								'elementType': 'labels',
								'stylers': {
									'visibility': 'off'
								}
							}, {
								'featureType': 'boundary',
								'elementType': 'all',
								'stylers': {
									'color': '#fefefe'
								}
							}, {
								'featureType': 'building',
								'elementType': 'all',
								'stylers': {
									'color': '#d1d1d1'
								}
							}, {
								'featureType': 'label',
								'elementType': 'labels.text.fill',
								'stylers': {
									'color': '#999999'
								}
							}]
						}
					},
					series: [{
							name: 'pm2.5',
							type: 'scatter',
							coordinateSystem: 'bmap',
							data: _this.convertData(data),
							symbolSize: function(val) {
								return val[2] / 10;
							},
							label: {
								normal: {
									formatter: '{b}',
									position: 'right',
									show: false
								},
								emphasis: {
									show: true
								}
							},
							itemStyle: {
								normal: {
									color: 'purple'
								}
							}
						},
						{
							name: 'Top 5',
							type: 'effectScatter',
							coordinateSystem: 'bmap',
							data: _this.convertData(data.sort(function(a, b) {
								return b.value - a.value;
							}).slice(0, 6)),
							symbolSize: function(val) {
								return val[2] / 10;
							},
							showEffectOn: 'render',
							rippleEffect: {
								brushType: 'stroke'
							},
							hoverAnimation: true,
							label: {
								normal: {
									formatter: '{b}',
									position: 'right',
									show: true
								}
							},
							itemStyle: {
								normal: {
									color: 'purple',
									shadowBlur: 10,
									shadowColor: '#333'
								}
							},
							zlevel: 1
						}
					]
				};
				
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);

			}
		},
		mounted() {
			this.drawChart();
		}
	};
</script>
<style scoped="scoped">
	#ditu-main{
		border: 1px solid #092537;
		min-width: 500px;
		min-height: 400px;
		height: 400px;
	}
</style>


// WEBPACK FOOTER //
// src/components/comm/home/ditu.vue